function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys1 = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys1 = ownKeys1.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys1.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { computed, defineComponent, reactive, ref, watch, getCurrentInstance } from "vue";
import FormPanel from "@/views/creative/components/form-panel.vue";
import { ElSchemaFormItem } from "el-schema-form";
import _ from "lodash";
import { ModelEditorProtocol, ModelEditorProtocolDataType } from "@/store/creative/model-editor/index.type";
import ResetResource from "@/views/creative/components/reset-resource.vue";
import { language } from "@/common/storage";
import DialogForm from "@/components/DialogForm/index.vue";
import isMaterialWarehouse from "@/common/is-warehouse";
export default defineComponent({
    components: {
        DialogForm: DialogForm,
        ResetResource: ResetResource,
        FormPanel: FormPanel,
        ElSchemaFormItem: ElSchemaFormItem
    },
    setup: function setup(props) {
        var postMessage = function postMessage(data) {
            store.dispatch("creative/template/previewer/postMessage", {
                target: "previewer",
                type: ModelEditorProtocol,
                data: data
            });
        };
        var handleReset = function handleReset(param) {
            var prop = param.prop, index = param.index;
            var originalData = originalOrbitParams.value[index];
            handleChangeItem(index, {
                prop: prop,
                value: originalData[prop]
            });
        };
        var handleChangeItem = function handleChangeItem(index, event) {
            var targetOldData = _.cloneDeep(orbitParams.value[index]);
            targetOldData[event.prop] = event.value;
            store.commit("creative/modelEditor/setOrbitParams", targetOldData);
        };
        var openI18nDialog = function openI18nDialog(index) {
            dialogConfig.visible = true;
            dialogValue.value.index = index;
            dialogValue.value.name = sceneList.value[index].title;
            dialogValue.value.name_en = sceneList.value[index].title_en;
        };
        var handleSubmit = function handleSubmit() {
            handleChangeItem(dialogValue.value.index, {
                prop: "title",
                value: dialogValue.value.name
            });
            handleChangeItem(dialogValue.value.index, {
                prop: "title_en",
                value: dialogValue.value.name_en
            });
            dialogConfig.visible = false;
        };
        var instance = getCurrentInstance();
        var root = instance === null || instance === void 0 ? void 0 : instance.proxy;
        var store = root.$store;
        var activeNames = ref([]);
        var handleChange = function(value) {
            activeNames.value = value;
        };
        var orbitParams = computed(function() {
            return store.state.creative.modelEditor.cameraAdaptConfig.orbitParams;
        });
        watch(function() {
            return orbitParams.value;
        }, function(newVal, oldVal) {
            if (JSON.stringify(newVal) !== JSON.stringify(oldVal)) {
                var name, propertyName, value;
                newVal.forEach(function(item, index) {
                    // @ts-ignore
                    Object.keys(item).forEach(function(key) {
                        if (item[key] !== oldVal[index][key]) {
                            name = item.name;
                            propertyName = key;
                            value = item[key];
                        }
                    });
                });
                postMessage({
                    type: ModelEditorProtocolDataType.cameraOrbit,
                    data: {
                        name: name,
                        propertyName: propertyName,
                        value: value
                    }
                });
            }
        }, {
            deep: true
        });
        var model = computed({
            get: function() {
                return orbitParams.value;
            },
            set: function(value) {
            //
            }
        });
        var sceneList = computed(function() {
            return orbitParams.value.map(function(item) {
                return _objectSpreadProps(_objectSpread({}, item), {
                    displayName: language.get() === "en" ? item.title_en || item.title : item.title
                });
            });
        });
        var sceneConfigList = computed(function() {
            return [
                {
                    title: root.$t("playTurbo.custom.scene.polarAngle").toString(),
                    type: "polarAngle"
                },
                {
                    title: root.$t("playTurbo.custom.scene.azimuthAngle").toString(),
                    type: "azimuthAngle"
                },
                {
                    title: root.$t("playTurbo.custom.scene.radialDistance").toString(),
                    type: "radialDistance"
                },
                {
                    title: root.$t("playTurbo.custom.scene.viewOffsetX").toString(),
                    type: "viewOffsetX"
                },
                {
                    title: root.$t("playTurbo.custom.scene.viewOffsetY").toString(),
                    type: "viewOffsetY"
                },
                {
                    title: root.$t("playTurbo.custom.scene.viewOffsetZ").toString(),
                    type: "viewOffsetZ"
                },
                {
                    title: root.$t("playTurbo.custom.scene.dampingFactor").toString(),
                    type: "dampingFactor"
                }, 
            ];
        });
        var formItemList = computed(function() {
            return {
                polarAngle: {
                    prop: "polarAngle",
                    component: "slider",
                    field: {
                        min: 0,
                        max: 180,
                        step: 1,
                        showTooltip: false
                    }
                },
                azimuthAngle: {
                    prop: "azimuthAngle",
                    component: "slider",
                    field: {
                        min: 0,
                        max: 360,
                        step: 1,
                        showTooltip: false
                    }
                },
                radialDistance: {
                    prop: "radialDistance",
                    component: "slider",
                    field: {
                        min: 0,
                        max: 100,
                        step: 0.01,
                        showTooltip: false
                    }
                },
                viewOffsetX: {
                    prop: "viewOffsetX",
                    component: "slider",
                    field: {
                        min: -100,
                        max: 100,
                        step: 0.1,
                        showTooltip: false
                    }
                },
                viewOffsetY: {
                    prop: "viewOffsetY",
                    component: "slider",
                    field: {
                        min: -100,
                        max: 100,
                        step: 0.1,
                        showTooltip: false
                    }
                },
                viewOffsetZ: {
                    prop: "viewOffsetZ",
                    component: "slider",
                    field: {
                        min: -100,
                        max: 100,
                        step: 0.1,
                        showTooltip: false
                    }
                },
                dampingFactor: {
                    prop: "dampingFactor",
                    component: "slider",
                    field: {
                        min: 0.001,
                        max: 1,
                        step: 0.001,
                        showTooltip: false
                    }
                }
            };
        });
        var originalOrbitParams = computed(function() {
            return store.state.creative.template.originalJson.cameraConfig.orbitParams;
        });
        var dialogConfig = reactive({
            visible: false,
            loading: false,
            width: "500px",
            title: "\u7F16\u8F91\u955C\u5934\u540D\u79F0",
            labelPosition: "left",
            appendToBody: true
        });
        var dialogValue = ref({
            index: 0,
            name: "",
            name_en: ""
        });
        var dialogFormConfig = reactive({
            labelPosition: "left",
            labelWidth: "150px",
            size: "mini"
        });
        var dialogItemList = computed(function() {
            return [
                {
                    label: "\u4E2D\u6587\u540D\u79F0",
                    type: "input",
                    prop: "name",
                    rules: [
                        {
                            required: true
                        }, 
                    ]
                },
                {
                    label: "\u82F1\u6587\u540D\u79F0",
                    type: "input",
                    prop: "name_en",
                    rules: [
                        {
                            required: true
                        }, 
                    ]
                }, 
            ];
        });
        return {
            activeNames: activeNames,
            model: model,
            sceneList: sceneList,
            sceneConfigList: sceneConfigList,
            formItemList: formItemList,
            handleChange: handleChange,
            handleReset: handleReset,
            handleChangeItem: handleChangeItem,
            isMaterialWarehouse: isMaterialWarehouse,
            dialogConfig: dialogConfig,
            dialogValue: dialogValue,
            dialogFormConfig: dialogFormConfig,
            dialogItemList: dialogItemList,
            openI18nDialog: openI18nDialog,
            handleSubmit: handleSubmit
        };
    }
});
